import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  POST_LOGIN_API,
  POST_LOGIN_SMS_CODE,
  SupplierSmsCodeSendParams,
  SupplierSmsLoginParams,
} from '../../api/CommonApi'
import { setAuthtokenAction } from '../../modules/authtoken'
import { setLoginInfoAction } from '../../modules/homedata'
import Login from '../../modules/login'
import type { LoginNotice } from '../../modules/login'
import { history } from '../../redux/store'
import { usePermissionStore } from '../../stores/permission'
import {
  DelLocalStorage,
  GetLocalStorage,
  SetLocalStorage,
  decodeAuthToken,
  isResponseCodeSuccess,
  RoleTypeParam,
} from '../../tools/util'

const ROLE_VALUES: RoleTypeParam[] = [
  'SOURCE_ASSESS_MAN',
  'SOURCE_ASSESS_MANAGER',
  'SOURCE_PURCHASE_MAN',
  'SOURCE_DATA_MAN',
  'SOURCE_PRODUCT_ASSISTANT',
  'root',
]

const isRoleType = (value: string): value is RoleTypeParam =>
  ROLE_VALUES.includes(value as RoleTypeParam)

const LoginPage = () => {
  const [countdown, setCountdown] = useState(0)
  const [loginLoading, setLoginLoading] = useState(false)
  const [sendLoading, setSendLoading] = useState(false)
  const [notice, setNotice] = useState<LoginNotice>()
  const dispatchRedux = useDispatch()
  const setPermission = usePermissionStore((state) => state.setPermission)

  useEffect(() => {
    try {
      const token = GetLocalStorage('SRM_TOKEN')
      const expiresAt = Number(decodeAuthToken(token).exp) * 1000
      if (expiresAt > Date.now()) {
        history.replace('/srm/home')
      } else {
        DelLocalStorage('SRM_TOKEN')
      }
    } catch {
      DelLocalStorage('SRM_TOKEN')
    }
  }, [])

  useEffect(() => {
    if (countdown <= 0) {
      return
    }
    const timer = window.setTimeout(() => {
      setCountdown((value) => Math.max(0, value - 1))
    }, 1000)
    return () => window.clearTimeout(timer)
  }, [countdown])

  const handleSendCode = async (params: SupplierSmsCodeSendParams) => {
    setNotice(undefined)
    setSendLoading(true)
    try {
      const res = await POST_LOGIN_SMS_CODE(params)
      if (isResponseCodeSuccess(res.code)) {
        setNotice({ message: '验证码已发送', type: 'success' })
        setCountdown(60)
        return
      }
      setNotice({
        message: res.msg || '验证码发送失败，请稍后重试',
        type: 'error',
      })
    } catch {
      setNotice({
        message: '验证码发送失败，请稍后重试',
        type: 'error',
      })
    } finally {
      setSendLoading(false)
    }
  }

  const handleClickLogin = async (params: SupplierSmsLoginParams) => {
    DelLocalStorage('SRM_TOKEN')
    DelLocalStorage('SUPPLIERID')
    setNotice(undefined)
    setLoginLoading(true)
    try {
      const res = await POST_LOGIN_API(params)
      if (!isResponseCodeSuccess(res.code)) {
        setNotice({
          message: res.msg || '登录失败，请稍后重试',
          type: 'error',
        })
        return
      }

      SetLocalStorage('SRM_TOKEN', `${res.data.token}`)
      SetLocalStorage('USERID', `${res.data.supplierUserId}`)
      SetLocalStorage('SUPPLIERID', `${res.data.supplierId}`)
      SetLocalStorage('SUPPLIER_CODE', `${res.data.code}`)
      SetLocalStorage('SUPPLIER_ERPCODE', `${res.data.erpCode}`)
      SetLocalStorage('USER_NAME', `${res.data.realName}`)
      SetLocalStorage('SUPPLIER_NAME', `${res.data.name}`)
      SetLocalStorage('BASEURL', `${res.data.baseUrl}`)
      SetLocalStorage('ROLE', `${res.data.role}`)
      SetLocalStorage('COOPERATETYPE', `${res.data.cooperateType}`)
      SetLocalStorage('SUPPLIER_MDM_CODE', `${res.data.mdmCode}`)
      SetLocalStorage('MENU_LIST', res.data.menus)
      setPermission(res.data.permissionNameList)
      const info = decodeAuthToken(`${res.data.token}`)
      dispatchRedux(
        setAuthtokenAction({
          ...info,
          role: isRoleType(res.data.role) ? res.data.role : info.role,
          cooperateType:
            res.data.cooperateType === '1' ||
            res.data.cooperateType === '2' ||
            res.data.cooperateType === '3'
              ? res.data.cooperateType
              : info.cooperateType,
        }),
      )
      dispatchRedux(setLoginInfoAction(res.data))
      history.replace({
        pathname: '/srm/home',
        state: {
          supplierId: `${res.data.supplierId}`,
        },
      })
    } catch {
      setNotice({ message: '登录失败，请稍后重试', type: 'error' })
    } finally {
      setLoginLoading(false)
    }
  }

  return (
    <Login
      countdown={countdown}
      handleClickLogin={handleClickLogin}
      handleSendCode={handleSendCode}
      loginLoading={loginLoading}
      notice={notice}
      onNoticeClose={() => setNotice(undefined)}
      sendLoading={sendLoading}
    />
  )
}

export default LoginPage
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  POST_LOGIN_API,
  POST_LOGIN_SMS_CODE,
  SupplierSmsCodeSendParams,
  SupplierSmsLoginParams,
} from '../../api/CommonApi'
import { setAuthtokenAction } from '../../modules/authtoken'
import { setLoginInfoAction } from '../../modules/homedata'
import Login from '../../modules/login'
import type { LoginNotice } from '../../modules/login'
import { history } from '../../redux/store'
import { usePermissionStore } from '../../stores/permission'
import {
  DelLocalStorage,
  GetLocalStorage,
  SetLocalStorage,
  decodeAuthToken,
  isResponseCodeSuccess,
  RoleTypeParam,
} from '../../tools/util'

const ROLE_VALUES: RoleTypeParam[] = [
  'SOURCE_ASSESS_MAN',
  'SOURCE_ASSESS_MANAGER',
  'SOURCE_PURCHASE_MAN',
  'SOURCE_DATA_MAN',
  'SOURCE_PRODUCT_ASSISTANT',
  'root',
]

const isRoleType = (value: string): value is RoleTypeParam =>
  ROLE_VALUES.includes(value as RoleTypeParam)

const LoginPage = () => {
  const [countdown, setCountdown] = useState(0)
  const [loginLoading, setLoginLoading] = useState(false)
  const [sendLoading, setSendLoading] = useState(false)
  const [notice, setNotice] = useState<LoginNotice>()
  const dispatchRedux = useDispatch()
  const setPermission = usePermissionStore((state) => state.setPermission)

  useEffect(() => {
    try {
      const token = GetLocalStorage('SRM_TOKEN')
      const expiresAt = Number(decodeAuthToken(token).exp) * 1000
      if (expiresAt > Date.now()) {
        history.replace('/srm/home')
      } else {
        DelLocalStorage('SRM_TOKEN')
      }
    } catch {
      DelLocalStorage('SRM_TOKEN')
    }
  }, [])

  useEffect(() => {
    if (countdown <= 0) {
      return
    }
    const timer = window.setTimeout(() => {
      setCountdown((value) => Math.max(0, value - 1))
    }, 1000)
    return () => window.clearTimeout(timer)
  }, [countdown])

  const handleSendCode = async (params: SupplierSmsCodeSendParams) => {
    setNotice(undefined)
    setSendLoading(true)
    try {
      const res = await POST_LOGIN_SMS_CODE(params)
      if (isResponseCodeSuccess(res.code)) {
        setNotice({ message: '验证码已发送', type: 'success' })
        setCountdown(60)
        return
      }
      setNotice({
        message: res.msg || '验证码发送失败，请稍后重试',
        type: 'error',
      })
    } catch {
      setNotice({
        message: '验证码发送失败，请稍后重试',
        type: 'error',
      })
    } finally {
      setSendLoading(false)
    }
  }

  const handleClickLogin = async (params: SupplierSmsLoginParams) => {
    DelLocalStorage('SRM_TOKEN')
    DelLocalStorage('SUPPLIERID')
    setNotice(undefined)
    setLoginLoading(true)
    try {
      const res = await POST_LOGIN_API(params)
      if (!isResponseCodeSuccess(res.code)) {
        setNotice({
          message: res.msg || '登录失败，请稍后重试',
          type: 'error',
        })
        return
      }

      SetLocalStorage('SRM_TOKEN', `${res.data.token}`)
      SetLocalStorage('USERID', `${res.data.supplierUserId}`)
      SetLocalStorage('SUPPLIERID', `${res.data.supplierId}`)
      SetLocalStorage('SUPPLIER_CODE', `${res.data.code}`)
      SetLocalStorage('SUPPLIER_ERPCODE', `${res.data.erpCode}`)
      SetLocalStorage('USER_NAME', `${res.data.realName}`)
      SetLocalStorage('SUPPLIER_NAME', `${res.data.name}`)
      SetLocalStorage('BASEURL', `${res.data.baseUrl}`)
      SetLocalStorage('ROLE', `${res.data.role}`)
      SetLocalStorage('COOPERATETYPE', `${res.data.cooperateType}`)
      SetLocalStorage('SUPPLIER_MDM_CODE', `${res.data.mdmCode}`)
      SetLocalStorage('MENU_LIST', res.data.menus)
      setPermission(res.data.permissionNameList)
      const info = decodeAuthToken(`${res.data.token}`)
      dispatchRedux(
        setAuthtokenAction({
          ...info,
          role: isRoleType(res.data.role) ? res.data.role : info.role,
          cooperateType:
            res.data.cooperateType === '1' ||
            res.data.cooperateType === '2' ||
            res.data.cooperateType === '3'
              ? res.data.cooperateType
              : info.cooperateType,
        }),
      )
      dispatchRedux(setLoginInfoAction(res.data))
      history.replace({
        pathname: '/srm/home',
        state: {
          supplierId: `${res.data.supplierId}`,
        },
      })
    } catch {
      setNotice({ message: '登录失败，请稍后重试', type: 'error' })
    } finally {
      setLoginLoading(false)
    }
  }

  return (
    <Login
      countdown={countdown}
      handleClickLogin={handleClickLogin}
      handleSendCode={handleSendCode}
      loginLoading={loginLoading}
      notice={notice}
      onNoticeClose={() => setNotice(undefined)}
      sendLoading={sendLoading}
    />
  )
}

export default LoginPage
